import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as userActions from "../../../../actions/user.actions";

import EmailPreferences from "../components/EmailPreferences";

class EmailPreferencesContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.userActions.getUserData();
    this.props.userActions.getEmailTypes();
    this.props.userActions.getEmailTypesOptions();
  }

  handleSubmit(data) {
    const payload = {
      id: this.props.user.id,
      email_preferences: data
    };

    this.props.userActions.updateEmailPreferences(payload);
  }

  render() {
    return (
      <EmailPreferences
        options={this.props.options}
        types={this.props.types}
        user={this.props.user}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data,
    options: state.user.email.options,
    types: state.user.email.types
  };
};

const mapDispatchToProps = dispatch => {
  return {
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailPreferencesContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/emailPreferences/containers/EmailPreferencesContainer.js